import { Dispatch, SetStateAction, useEffect, useState } from 'react';

type SetState<Val> = Dispatch<SetStateAction<Val>>;

const useAnimationTrigger = (missTrigger?: boolean): [boolean, SetState<boolean>] => {
  const [animationTrigger, setAnimationTrigger] = useState(false);

  useEffect(() => {
    if (!missTrigger) {
      requestAnimationFrame(() => setAnimationTrigger(true));
    }
  }, []);

  return [animationTrigger, setAnimationTrigger];
};

export default useAnimationTrigger;
